export default "__VITE_ASSET__BLUBOURx__"